import React from 'react';

const EligibilityDescription = (
  <>
    <p>
      First, we’ll ask a few questions about you and the Veteran who’s
      sponsoring the applicants.
    </p>
    <p>
      We’ll use the Veteran’s information to confirm the eligibility of the
      Veteran and the applicants who need CHAMPVA benefits. You won’t need to
      upload the Veteran’s DD214.
    </p>
  </>
);

export default EligibilityDescription;
